import axios from 'axios'


axios.defaults.headers.post['Content-Type'] = "application/json";

const service = axios.create({
    baseURL: 'https://api.eztcloud.com/',
    timeout: 30000
})



service.interceptors.request.use(config => {
    if (config.headers['x-cos-security-token']) {
        return config
    }

    return config
}, error => {
    Promise.reject(error)
})




export default service


